import { Stack } from "@mui/material";
import { HunterDetailTransactionFees } from "Components/Transactions/UserTransactionFees/HunterDetailTransactionFees";
import { SettlementDownloadSection } from "Components/Transactions/UserTransactionFees/SettlementDownloadSection";
import type { SettlementUserRole } from "Types/settlements";

type Props = {
  userID: number;
  partyPublicID: string;
  userRole: SettlementUserRole;
};

export const HunterTransactionFees = ({
  userID,
  partyPublicID,
  userRole,
}: Props) => (
  <Stack gap={2}>
    <HunterDetailTransactionFees userID={userID} />
    <SettlementDownloadSection
      partyPublicID={partyPublicID}
      userRole={userRole}
    />
  </Stack>
);
